<template>
    <div class="wrapper">
        <div class="header">
            <BaseHeader :title="'商品详情'"/>
        </div>
        <div class="content">
            <div class="swipe">
                <van-swipe :autoplay="3000">
                    <van-swipe-item v-for="(image, index) in goodsInfo.banners" :key="index">
                        <img v-lazy="image" class="swipe-img" style="height: 375px"/>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="goods-info">
                <div class="item">
                    <van-cell title="商品名称" :value="goodsInfo.name" />
                </div>
                <div class="item">
                    <van-cell title="商品描述" :value="goodsInfo.title" />
                </div>
                <div class="item price">
                    <van-cell title="兑换价格" :value="price + '个'" />
                </div>
                <div class="item price" v-show="tbBalance">
                    <van-cell title="淘宝价格" :value="tbBalance + '元'" />
                </div>
                <div class="item price" v-show="jdBalance">
                    <van-cell title="商京东格" :value="jdBalance + '元'" />
                </div>
                <div class="item">
                    <van-cell title="商品库存" :value="stock" />
                </div>
                <div class="item stock">
                    <div>兑换数量</div>
                    <div>
                        <van-stepper v-model="selectionStock" min="1" :max="stock"  @change="handleChangeStock" :disable-input="true"/>
                    </div>
                </div>
                <div class="item size-box" v-if="goodsInfo.is_specs === 1">
                    <div>规格</div>
                    <div class="size-list">
                        <div class="size-item" v-for="(item,index) in goodsInfo.specs" :key="index" >
                            <van-tag round :class="tagTypeIndex === index ? 'active' : '' " @click="handleChangeSize(index,item.num_stock,item.hb_num,item.id,item.spec_str,item.tb_price,item.jd_price)">{{item.spec_str}}</van-tag>
                        </div>
                    </div>
                </div>
                <div class="item" v-html="goodsInfo.content"></div>
            </div>
            <div class="goods-btn">
                <van-submit-bar :price="total" button-text="兑换" @submit="handleDH">
                    <div>可用红包数量：<span style="color: #f20">{{userPrice}}</span></div>
                </van-submit-bar>
            </div>
        </div>
    </div>
</template>

<script>
    import {getGoodsDetailsService} from "../service/goodsService";
    import {convertedCommoditiesService} from "../service/userService";
    import {Toast,Dialog} from 'vant';
    import BaseHeader from "../components/BaseHeader";
    import {mapState,mapActions} from 'vuex';
	//import {wecharShare} from "../util/weChat.js";

    export default {
        name: "ShopDetails",
        data(){
            return{
                shopId:null,
                goodsId:null,
                goodsInfo:{},
                price:0,//单价
                total:0,//总价
                stock:0,//库存
                selectionStock:1,//选中的库存
                tagTypeIndex:0,
                tbBalance:0,//淘宝价格
                jdBalance:0,//京东价格
                specId:0,//规格编号
                specText:'',//规格描述
            }
        },
        mounted(){
            this.shopId = this.$route.params.shopId;
            this.goodsId = this.$route.params.goodsId;
            this.getGoodsDetails();
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods:{
            ...mapActions(['setPrice']),

            //切换规格
            handleChangeSize(index,stock,price,specId,specText,tbBalance,jdBalance){
                this.tagTypeIndex = index;
                this.stock = stock;
                this.price = price;
                this.total = this.price * 100 * this.selectionStock;
                this.specId = specId;
                this.specText = specText;
                this.tbBalance = tbBalance;
                this.jdBalance = jdBalance;

            },

            //选择兑换数量
            handleChangeStock(){
                this.total = this.price * 100 * this.selectionStock;
            },

            //兑换
            handleDH(){
                Dialog.confirm({
                    title: '提示',
                    message: '是否兑换'
                }).then(() => {
                    if(Number(this.userPrice) - Number(this.total) / 100 < 0){
                        Toast('您的红包数量不足，无法兑换');
                        return;
                    }
                    console.log(this.specText)
                    convertedCommoditiesService(this.userId,this.total,this.goodsId,this.specId,this.selectionStock,this.shopId,this.tbBalance,this.jdBalance,this.goodsInfo.name,this.goodsInfo.logo,this.specText,this.price).then(res => {
                        if(res.status === 1){
                            Toast('兑换成功');
                            const price = (Number(this.userPrice) - Number(this.total) / 100).toFixed(2);
                            this.stock -= this.selectionStock;
                            this.setPrice(price);
                        }else{
                            Toast(res.msg);
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }).catch(() => {
                    // on cancel
                });
            },

            //获取商品详情
            getGoodsDetails(){
                if(!this.shopId || !this.goodsId){
                    Toast('商品信息获取失败，请联系管理员');
                    return;
                }
                getGoodsDetailsService(this.shopId,this.goodsId).then(res => {
                    if(res.status === 1){
                        this.goodsInfo = res.datas;
                        this.specId = this.goodsInfo.specs[0].id;//规格编号
                        this.price = Number(this.goodsInfo.specs[0].hb_num);//单价
                        this.specText = this.goodsInfo.specs[0].spec_str;//规格描述
                        this.tbBalance = Number(this.goodsInfo.specs[0].tb_price);//淘宝价格
                        this.jdBalance = Number(this.goodsInfo.specs[0].jd_price);//京东价格
                        this.total = this.price * 100;//合计金额
                        this.stock = this.goodsInfo.specs[0].num_stock;//库存
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        },
        computed:{
            ...mapState({
                userId: state => state.userInfo.userId,
                userPrice: state => state.userInfo.userPrice,
            })
        },
        components:{
            BaseHeader,
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        /*.header{*/
        /*    margin-bottom: 46px;*/
        /*}*/
        .content{

            .swipe{
                background: #ffffff;
                .swipe-img{
                    width: 100%;
                    height: 100%;
                }
            }
            .goods-info{
                padding-bottom: 60px;
                .stock{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: #ffffff;
                    height: 44px;
                    padding: 0 13px;
                    font-size: 14px;
                    box-sizing: border-box;
                }
                .size-box{
                    background: #ffffff;
                    padding: 10px 13px;
                    font-size: 14px;
                    box-sizing: border-box;
                    .size-list{
                        margin-top: 5px;
                        display: flex;
                        align-items: center;
                        .size-item{
                            margin: 5px;
                            .active{
                                background: red;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<style>
    .goods-info img{
        width: 100%;
        height: 100%;
        display: block;
    }
    .price .van-cell__value span{
        color: #f20;
    }
</style>